export default "__VITE_ASSET__aa1f3952__"